// // Copied from https://github.com/mariusandra/pigeon-marker

import PropTypes from 'prop-types'
import React from "react"
import Icon from "../../components/icons/Icon"

const imageOffset = {
  left: 15,
  top: 31
}

export default class MyMarker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hover: false
    }
  }

  // what do you expect to get back with the event
  eventParameters(event) {
    return ({
      event,
      anchor: this.props.anchor,
      payload: this.props.payload
    }) 
  }

  // delegators, maybe one day they will be useful

  /*handleClick = (event) => {
    this.props.onClick && this.props.onClick(this.eventParameters(event))
  }

  handleContextMenu = (event) => {
    this.props.onContextMenu && this.props.onContextMenu(this.eventParameters(event))
  }

  handleMouseOver = (event) => {
    this.props.onMouseOver && this.props.onMouseOver(this.eventParameters(event))
    this.setState({ hover: true })
  }

  handleMouseOut = (event) => {
    this.props.onMouseOut && this.props.onMouseOut(this.eventParameters(event))
    this.setState({ hover: false })
  }*/

  // render

  render() {
    const { left, top, onClick } = this.props

    const style = {
      position: 'absolute',
      transform: `translate(${left - imageOffset.left}px, ${top - imageOffset.top}px)`,
      cursor: onClick ? 'pointer' : 'default'
    }

    return (
      <div style={style}
        className='pigeon-click-block'
        onClick={this.handleClick}
        onContextMenu={this.handleContextMenu}
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}>
        <Icon name="marker" />      
      </div>
    )
  }
}

MyMarker.propTypes = {
  // input, passed to events
  anchor: PropTypes.array.isRequired,
  payload: PropTypes.any,

  // optional modifiers
  hover: PropTypes.bool,

  // callbacks
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,

  // pigeon variables
  left: PropTypes.number,
  top: PropTypes.number,

  // pigeon functions
  latLngToPixel: PropTypes.func,
  pixelToLatLng: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/MyMarker.jsx